export const CHATROOM_MESSAGES_LIMIT = 20
